import { Editor } from '@monaco-editor/react';

export function CodeEditor({ value, onChange, readonly }: { value: string; onChange?: (value: string) => void; readonly?: boolean }) {
    return (
        <Editor
            height="100%"
            defaultLanguage="json"
            value={value}
            onChange={(value) => onChange?.(value || '')}
            options={{
                readOnly: readonly,
                minimap: { enabled: false },
                scrollBeyondLastLine: false,
                fontSize: 13,
                lineNumbers: 'on',
                roundedSelection: false,
                automaticLayout: true,
                wordWrap: 'on',
                tabSize: 2,
                insertSpaces: true,
                formatOnPaste: true,
                formatOnType: false,
                suggest: {
                    showKeywords: true,
                    showSnippets: true,
                },
            }}
            theme="vs"
        />
    );
}
